import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-433">
      <div className="max-w-5xl mx-auto" data-id="element-434">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-435">
          Lo que <span className="text-[#00B4D8]" data-id="element-436">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-437">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-438">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-439">
              🇫🇷 A1.1 → B1 — 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-440">
              Para docentes de Francés de secundaria e institutos
            </p>
            <div className="space-y-4" data-id="element-441">
              <div className="flex items-center gap-3 text-white" data-id="element-442">
                <span className="text-xl" data-id="element-443">📘</span>
                <div className="flex-1" data-id="element-444">
                  <span className="font-bold" data-id="element-445">
                    Tomo 1 — Nivel A1.1: El Despertar
                  </span>
                  <span className="text-gray-300" data-id="element-446">
                    {' '}
                    Saludos, identidad, números, abecedario, familia, rutinas,
                    entorno y gustos. Pronombres personales, ÊTRE, AVOIR y
                    verbos en -ER.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-447">
                <span className="text-xl" data-id="element-448">📗</span>
                <div className="flex-1" data-id="element-449">
                  <span className="font-bold" data-id="element-450">
                    Tomo 2 — Nivel A1.2: La Consolidación
                  </span>
                  <span className="text-gray-300" data-id="element-451">
                    {' '}
                    Cuerpo y salud, ropa y compras, la casa, el tiempo y las
                    estaciones, alimentos y restaurante, pasado reciente y
                    futuro inmediato. Partitivos, avoir mal à y verbos
                    impersonales.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-452">
                <span className="text-xl" data-id="element-453">📙</span>
                <div className="flex-1" data-id="element-454">
                  <span className="font-bold" data-id="element-455">
                    Tomo 3 — Nivel A2: La Autonomía
                  </span>
                  <span className="text-gray-300" data-id="element-456">
                    {' '}
                    Passé composé, imparfait, viajes y transportes, escuela y
                    trabajo, tecnología y redes sociales, comparaciones y
                    opiniones. Devoir/Pouvoir/Vouloir y verbos pronominales.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-457">
                <span className="text-xl" data-id="element-458">📕</span>
                <div className="flex-1" data-id="element-459">
                  <span className="font-bold" data-id="element-460">
                    Tomo 4 — Nivel B1: La Interacción Real
                  </span>
                  <span className="text-gray-300" data-id="element-461">
                    {' '}
                    Subjonctif, conditionnel, cultura francesa y francófona,
                    sociedad y debate, literatura y textos auténticos,
                    producción escrita y oral avanzada. Pronombres relativos y
                    discours indirect.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-462">
                <span className="text-xl" data-id="element-463">📓</span>
                <div className="flex-1" data-id="element-464">
                  <span className="font-bold" data-id="element-465">
                    Tomo 5 — Todos los Niveles: La Valija de Juegos
                  </span>
                  <span className="text-gray-300" data-id="element-466">
                    {' '}
                    80 dinámicas listas para el aula: vocabulario, gramática,
                    expresión oral, comprensión lectora, escritura creativa y
                    cultura. Sin tecnología. Para grupos de 20 a 40 alumnos.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-467">
                <span className="text-xl" data-id="element-468">📔</span>
                <div className="flex-1" data-id="element-469">
                  <span className="font-bold" data-id="element-470">
                    Tomo 6 — Gestión Total: El Gestor Administrativo
                  </span>
                  <span className="text-gray-300" data-id="element-471">
                    {' '}
                    24 exámenes completos (4 por nivel), rúbricas de evaluación,
                    planificaciones anuales listas, planillas de calificaciones,
                    informes para familias, autoevaluación del alumno y
                    Solucionario Maestro.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-472">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-473">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-474">
            <div className="flex items-start gap-2 text-left" data-id="element-475">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-476">✅</span>
              <span className="text-white text-sm" data-id="element-477">
                Planificación anual completa lista para entregar a jefatura o
                dirección del instituto
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-478">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-479">✅</span>
              <span className="text-white text-sm" data-id="element-480">
                6 Bloques temáticos con desarrollo completo y ejemplos reales
                del aula argentina
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-481">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-482">✅</span>
              <span className="text-white text-sm" data-id="element-483">
                Secuencias didácticas con estructura presentación–práctica
                guiada–práctica libre–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-484">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-485">✅</span>
              <span className="text-white text-sm" data-id="element-486">
                Actividades fotocopiables listas para imprimir o proyectar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-487">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-488">✅</span>
              <span className="text-white text-sm" data-id="element-489">
                6 Evaluaciones parciales + 1 Evaluación Final Integradora por
                nivel con criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-490">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-491">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-492">
                SOLUCIONARIO COMPLETO con todas las respuestas y justificaciones
                gramaticales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-493">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-494">✅</span>
              <span className="text-white text-sm" data-id="element-495">
                Glosario temático por bloque para el alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-496">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-497">✅</span>
              <span className="text-white text-sm" data-id="element-498">
                Sección de errores de interferencia español-francés integrada en
                todos los niveles
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-499">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-500">✅</span>
              <span className="text-white text-sm" data-id="element-501">
                Conexión cultural Francia y francofonía en cada bloque
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-502">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-503">✅</span>
              <span className="text-white text-sm" data-id="element-504">
                100% alineado al Marco Común Europeo de Referencia (MCER)
                vigente
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-505">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-506">✅</span>
              <span className="text-white text-sm" data-id="element-507">
                Francés estándar moderno (no anticuado ni demasiado formal)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}